import * as urlUtil from '@tencent/vft-common/url';
import Version from '@tencent/vft-atom/lib/Version';
import atom from '@tencent/vft-atom';
import { getPlayright } from './videoPlayright';

/**
 * 在 h5 或 小程序 或 native 中打开
 * @return {String} h5/ weapp/ native
 */
const openType = function () {
  const env = window.magicApp?.env;
  const version = env?.appVersion;

  if (!version) return 'h5';

  const vObj = new Version(version);

  if (!vObj.compare('11.2.5')) return 'h5';

  const isIosOk = env.isIos && !vObj.compare('11.6.6');
  const isAndroidOk = (env.isAndroid && !vObj.compare('11.6.5'));

  if (isIosOk || isAndroidOk) {
    return 'weapp';
  }

  return 'native';
};

/**
 * 外层调用，返回 true 则 openurl 插件返回， 返回 false 则走原有逻辑
 * @return {Boolean}
 */
const mqbHandler = async function ({ cid, vid }) {
  if (!cid && !vid) return false;

  if (!window.magicApp?.env.isMqb) return false;

  const type = openType();

  if (type === 'h5') return false;

  if (type === 'weapp') {
    const path = urlUtil.buildUrl('pages/play/index.html', { cid, vid });
    atom.openUrl(`qb://wxapp/?appid=wxa75efa648b60994b&path=${encodeURIComponent(path)}&source=200007`);
    return true;
  }

  if (type === 'native') {
    const data = await getPlayright({ cid, vid });
    // eslint-disable-next-line
    if (!vid) vid = data.vid;

    const { playright } = data.fields;
    // 30 表示支持浏览器
    if (!playright || !playright.includes('30')) return false;

    const url = urlUtil.buildUrl('qb://tencentvideo?vidcontinue=1&source=200007', { cid, vid });
    atom.openUrl(url);
    return true;
  }

  return false;
};

export default mqbHandler;
